import { render, staticRenderFns } from "./BasicPersonalDocs.vue?vue&type=template&id=2a8d4841&"
import script from "./BasicPersonalDocs.vue?vue&type=script&lang=ts&"
export * from "./BasicPersonalDocs.vue?vue&type=script&lang=ts&"
import style0 from "./BasicPersonalDocs.vue?vue&type=style&index=0&id=2a8d4841&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports